// extracted by mini-css-extract-plugin
module.exports = {"editWorkflow":"EditWorkflowModal_editWorkflow__v0WU3"};